module.exports = __webpack_public_path__ + "img/js2.fae3066f.jpg";